import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';

export const templatePhasrRecommendations = document.createElement('template');

templatePhasrRecommendations.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='loading-container'>
        <gz-progress-spinner></gz-progress-spinner>
    </div>
    <gz-phasr-recommendations-grid></gz-phasr-recommendations-grid>
  </div>
`;
